const lang = {
  "list.workspace": "My Workspace",
  "list.workspace.li1": "All Contents",
  "list.workspace.li2": "Cases",
  "list.workspace.li3": "Documents",
  "list.workspace.li4": "Graph",

  "content.document": "Document",
  "content.graph": "Graph",
  "content.item": "File",
  "content.case": "Case",
  "content.data-source": "Data Source",
  "content.last-save": "Last Saved",
  "content.tag": "Tags",
  "content.note": "Notes",

  account: "Account",
  "account.account-setting": "Account Settings",
  "account.lang": "Language",
  "account.contact-us": "Contact Us",
  "account.logout": "Logout",

  "edit.view": "VIEW",
  "edit.refresh": "REFRESH",
  "edit.select": "SELECT",
  "edit.delete": "Delete",
  "edit.selected": "Selected",
  "edit.moveout": "Move Out",
  "edit.cancel": "Cancel",
  "edit.download": "Download",
  "edit.moveto": "Move To",

  "action.rename": "Rename",
  "action.delete": "Delete",
  "action.moveout": "Move Out",
  "action.moveto": "Move to case",
  "action.view-note": "View Notes",
  "action.view-tag": "View Tags",
  "action.create-newcase": "Create new case",

  "list.name": "Name",
  "list.last-modified": "Last Modified Time",
  "list.stock-code": "Stock Code",
  "list.document-issuer": "Document Issuer",
  "list.data-source": "Data Source",

  "tag.less": "LESS",
  "tag.more": "MORE",

  "dialog.confirm": ` Are you sure you want to delete ? This process cannot be
  undone.`,
  "dialog.ok": "OK",
  "dialog.cancel": "Cancel",
  "dialog.delete": "Delete",
  "dialog.newcase": "New Case",
  "dialog.action-confirm": "Confirm Your Action",
  "dialog.casename": "Case Name",
  "dialog.selected-items": "selected items",
  "dialog.rename-case": "Rename",

  loading: "loading...",

  "toast.success": "The processing is successful.",
  "toast.error": "Something went wrong.",
  "toast.pending": "Processing...",
  "toast.warning": "Please wait for the completion of last processing.",

  "dialog.tip1": "",
  "dialog.tip2": "*Please enter up to 32 characters",
  "dialog.tip3": "*The case name has been used",

  popover: "This document is contained in case:"
};
export default lang;



//////////////////
// WEBPACK FOOTER
// ./static/lang/en.js
// module id = null
// module chunks = 